import { Directive, ElementRef, ViewChild, inject } from '@angular/core';
import { CategoryViewComponentDef } from '@df/catalog-ui/category/view/category-view.component.def';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import '@df/module-giftcards/giftcards-category.on-load';
import { NgInject } from '@df/ng/ng-inject';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class GiftcardsCategoryViewComponentDef extends CategoryViewComponentDef {
    protected override canDetach = false;
    currentGiftcard?: number;

    /**
     * Configuration
     * important: you need to put #configuration on configuration component in template
     */
    @ViewChild('configuration', { static: false })
    configuration?: ElementRef;

    private scrollToService = inject(ScrollToService);

    selectGiftcard(giftcardId: number) {
        this.currentGiftcard = giftcardId;

        this.detectChanges();

        if (this.configuration) {
            this.timeoutService.setTimeout(() => {
                this.scrollToService.scrollTo(this.configuration!.nativeElement);
            }, 100);
        }
    }
}
